// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const serialize = (filterSet: any): string => {
  const filterParams: string[] = [];

  for (const key of Object.keys(filterSet)) {
    const value = filterSet[key];
    if (Array.isArray(value)) {
      value.forEach((x) => {
        filterParams.push(`${key}=${x}`);
      });
    } else if (value === undefined) {
      // No modificar el objeto original, solo usar string vacío en el query
      filterParams.push(`${key}=`);
    } else {
      filterParams.push(`${key}=${value}`);
    }
  }

  return filterParams.join('&');
};
